
import { MapLocation } from '@/types/location';

// Waki Schools in Eastern region
export const wakiSchoolsEastern: MapLocation[] = [
  {
    id: 40055,
    name: "Advanced Academic Dhahran Schools",
    type: "School",
    devices: 5,
    coordinates: [26.3126, 50.1284],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40056,
    name: "Al Hussan International School (Khobar)",
    type: "School",
    devices: 4,
    coordinates: [26.2765, 50.2047],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40057,
    name: "International Schools Group (ISG)",
    type: "School",
    devices: 6,
    coordinates: [26.3417, 50.1438],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40058,
    name: "Dhahran Ahliyya Schools",
    type: "School",
    devices: 5,
    coordinates: [26.3083, 50.1406],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40059,
    name: "Al-Jazeera International School (Dammam)",
    type: "School",
    devices: 3,
    coordinates: [26.4327, 50.0983],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 40060,
    name: "Manarat Al Sharqia International School",
    type: "School",
    devices: 4,
    coordinates: [26.3951, 50.1856],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 200
    }
  },
  {
    id: 41013,
    name: "University Schools - Dhahran",
    type: "School",
    devices: 12,
    coordinates: [26.299273, 50.153808],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary, Intermediate, Secondary",
      students: 2243
    }
  },
  {
    id: 41020,
    name: "Ajyal International School",
    type: "School",
    devices: 3,
    coordinates: [26.255042, 50.083577],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Tablets",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 517
    }
  }
];
